import { CommonAction, success } from "@iflyrpa/share";
import { ActiomCommonParams } from "../../types";
import { executeAction } from "../../utils";
import { rpaAction } from "./rpa";
import { rpaServer } from "./rpa-server";

export type DouyinLoginParams = ActiomCommonParams;

export type SteelAction = CommonAction<ActiomCommonParams, Record<string, unknown>>;

export const douyinLogin: SteelAction = async (task, params) => {
    if (params.actionType === "rpa") {
        return rpaAction(task, params);
    }

    if (params.actionType === "mockApi") {
        return success({}, "暂不支持mockApi");
    }

    if (params.actionType === "server") {
        return rpaServer(task, params);
    }

    return executeAction(rpaServer)(task, params);
};
